import { render, staticRenderFns } from "./ContentManager.vue?vue&type=template&id=2c93d941&scoped=true"
import script from "./ContentManager.vue?vue&type=script&lang=js"
export * from "./ContentManager.vue?vue&type=script&lang=js"
import style0 from "./ContentManager.vue?vue&type=style&index=0&id=2c93d941&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93d941",
  null
  
)

export default component.exports